import Vue from "vue";
import Router from "vue-router";
import store from "../../store";
import { setStore, getStore } from "@/utils/localUtil";
import { getCode } from "@/utils/auth";
Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  linkActiveClass: "is-active",
  routes: [
    {
      path: "/complement",
      component: (resolve) =>
        require(["../view/complement/index.vue"], resolve),
      meta: {
        title: "补充信息",
        keepAlive: false,
      },
    },
    {
      path: "/event",
      component: (resolve) =>
        require(["../view/visitor/event.vue"], resolve),
      meta: {
        title: "参加",
        keepAlive: false,
      },
    },
    {
      path: "/confirm",
      component: (resolve) =>
        require(["../view/signUp/confirm.vue"], resolve),
      meta: {
        title: "确认页",
        keepAlive: false,
      },
    },
    {
      path: "/article",
      component: (resolve) => require(["../view/home/article.vue"], resolve),
      meta: {
        title: "文章管理",
        keepAlive: false,
      },
    },
    {
      path: "/article-detail",
      component: (resolve) => require(["../view/home/articleDetail.vue"], resolve),
      meta: {
        title: "文章详情",
        keepAlive: false,
      },
    },
    {
      path: "/meet",
      component: (resolve) => require(["../view/meet/index.vue"], resolve),
      meta: {
        title: "会议报名",
        keepAlive: false,
      },
    },
    {
      path: "/invition",
      component: (resolve) => require(["../view/invite/invite.vue"], resolve),
      meta: {
        title: "邀请函",
        keepAlive: false,
      },
    },
    {
      path: "/notify",
      component: (resolve) => require(["../view/notify.vue"], resolve),
      meta: {
        title: "通知",
        keepAlive: false,
      },
    },

    {
      path: "/register",
      component: (resolve) => require(["../view/signUp/index.vue"], resolve),
      meta: {
        title: "登记信息",
        keepAlive: false,
      },
    },

    {
      path: "/registerEmail",
      component: (resolve) =>
        require(["../view/signUp/indexEmail.vue"], resolve),
      meta: {
        title: "登记信息",
        keepAlive: false,
      },
    },
    {
      path: "/registerEn",
      component: (resolve) => require(["../view/signUp/indexEn.vue"], resolve),
      meta: {
        title: "登记信息",
        keepAlive: false,
      },
    }, {
      path: "/form",
      component: (resolve) => require(["../view/signUp/form.vue"], resolve),
      meta: {
        title: "登记信息",
        keepAlive: false,
      },
    },
    {
      path: "/forumReg",
      component: (resolve) => require(["../view/forum/register.vue"], resolve),
      meta: {
        title: "论坛登记信息",
        keepAlive: false,
      },
    },
    {
      path: "/team",
      component: (resolve) => require(["../view/login/indexTeam.vue"], resolve),
      meta: {
        title: "团队登记",
        keepAlive: false,
      },
    },
    // 首页
    {
      path: "/getOpenId",
      component: (resolve) => require(["../view/getOpenId.vue"], resolve),
      meta: {
        title: "首页",
        keepAlive: false,
      },
    },
    {
      path: "/home",
      component: (resolve) => require(["../view/home/home.vue"], resolve),
      meta: {
        title: "首页",
        keepAlive: false,
      },
    },
    {
      path: "/info",
      component: (resolve) => require(["../view/home/info.vue"], resolve),
      meta: {
        title: "首页",
        keepAlive: false,
      },
    },
    {
      path: "/home1",
      component: (resolve) => require(["../view/home/home1.vue"], resolve),
      meta: {
        title: "首页",
        keepAlive: false,
      },
    },

    {
      path: "/search",
      component: (resolve) => require(["../view/search.vue"], resolve),
      meta: {
        title: "我的证件查询",
        keepAlive: false,
      },
    },
    {
      path: "/login",
      component: (resolve) => require(["../view/login/index.vue"], resolve),
      meta: {
        title: "观展预登记",
        keepAlive: false,
      },
    },
    {
      path: "/loginEn",
      component: (resolve) => require(["../view/login/indexEn.vue"], resolve),
      meta: {
        title: "观展预登记",
        keepAlive: false,
      },
    },
    {
      path: "/",
      component: (resolve) => require(["../view/ticket/index.vue"], resolve),
      meta: {
        title: "我的证件",
        keepAlive: false,
      },
    },
    {
      path: "/dynamicCode",
      component: (resolve) => require(["../view/ticket/dynamic.vue"], resolve),
      meta: {
        title: "动态码",
        keepAlive: false,
      },
    },

    {
      path: "/invite",
      component: (resolve) => require(["../view/invite/index.vue"], resolve),
      meta: {
        title: "我的邀请",
        keepAlive: false,
      },
    },
    // 论坛
    {
      path: "/forum",
      component: (resolve) => require(["../view/forum/index.vue"], resolve),
      meta: {
        title: "论坛报名",
        keepAlive: false,
      },
    },
    {
      path: "/forumDetail",
      component: (resolve) => require(["../view/forum/detail.vue"], resolve),
      meta: {
        title: "论坛报名详情",
        keepAlive: false,
      },
    },
    {
      path: "/forumOrder",
      component: (resolve) => require(["../view/forum/order.vue"], resolve),
      meta: {
        title: "论坛报名记录",
        keepAlive: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  // 做些什么，通常权限控制就在这里做哦

  if (JSON.stringify(store.getters.defaultInfo) == "{}") {
    store
      .dispatch("doGetSettings")
      .then((res) => {
        const { activity } = res.data.data;

        if (activity.status != "0") {
          next({
            path: "/notify",
          });
        } else {
          next();
        }
      })
      .catch(() => {
        next();
      });
  } else {
    next();
  }

  //}
});

export default router;
